import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'

const initialState = {
  loading: false,
  loadFailed: false,
  loaded: false,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const referralPayoutsListLoading = (state) =>
  updateObject(state, { loading: true })

const referralPayoutsListFailed = (state) =>
  updateObject(state, {
    loadFailed: true,
    loading: false,
    loaded: false,
  })

const referralPayoutsListSetList = (state, { payload }) => ({
  ...state,
  data: [...state.data, ...payload.data],
  loading: false,
  loaded: true,
})

const referralPayoutsListSetQuery = () => {}

const referralPayoutsListDropData = (state) =>
  updateObject(state, {
    ...state,
    ...initialState,
    filters: state.filters,
  })

const referralPayoutsListSetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REFERRAL/PAYOUTS_LIST_START_LOADING':
      return referralPayoutsListLoading(state, action)
    case 'REFERRAL/PAYOUTS_LIST_LOADING_FAILED':
      return referralPayoutsListFailed(state, action)
    case 'REFERRAL/PAYOUTS_LIST_SET_FILTER':
      return referralPayoutsListSetFilter(state, action)
    case 'REFERRAL/PAYOUTS_LIST_SET_LIST':
      return referralPayoutsListSetList(state, action)
    case 'REFERRAL/PAYOUTS_LIST_SET_QUERY':
      return referralPayoutsListSetQuery(state, action)
    case 'REFERRAL/PAYOUTS_LIST_DROP_DATA':
      return referralPayoutsListDropData(state)
    default:
      return state
  }
}

export default reducer
